import { Minute } from '@nu-art/ts-common';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_DiseaseProfileImport = {
    _v1: {
        validateDiseaseProfile: { method: HttpMethod.POST, path: '/v1/disease-profile-import/validate', timeout: 5 * Minute },
        importDiseaseProfile: { method: HttpMethod.POST, path: '/v1/disease-profile-import/import', timeout: 5 * Minute },
        attachHtml: { method: HttpMethod.POST, path: '/v1/disease-profile-import/attach-html', timeout: 5 * Minute },
    }
};
//# sourceMappingURL=apis-disease-profile-import.js.map